module.exports = __webpack_public_path__ + "static/img/group-7.fa85a4b.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/group-7.svg
// module id = 5V+G
// module chunks = 4